import { render, staticRenderFns } from "./Articles.page.vue?vue&type=template&id=d65916b8&"
import script from "./Articles.page.vue?vue&type=script&lang=js&"
export * from "./Articles.page.vue?vue&type=script&lang=js&"
import style0 from "./Articles.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports